import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { AlertTriangle } from "lucide-react";
import "./ProtectedRoute.css";

const ProtectedRoute = ({
  children,
  requiredPermissions = [],
  fallbackPath = "/dashboard",
}) => {
  const { user, hasPermission } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has any of the required permissions
  const hasAccess =
    requiredPermissions.length === 0 ||
    requiredPermissions.some((permission) => hasPermission(permission));

  if (!hasAccess) {
    return (
      <div className="access-denied">
        <div className="access-denied-content">
          <AlertTriangle size={48} className="access-denied-icon" />
          <h2>Access Denied</h2>
          <p>You don't have permission to access this page.</p>
          <p className="access-denied-role">
            Your role:{" "}
            <strong>
              {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
            </strong>
          </p>
          <button
            className="access-denied-btn"
            onClick={() => window.history.back()}
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
